import React, { useState } from "react";
import RevealAnimation from "../RevealAnimation";
import PracticeHeroContent from "../shared/PracticeHeroContent";
import Button from "../Button";
import RightArrowWhite from "../../assets/Icons/accordian_white.svg";
import "./ventureRyteHero.scss";
import { navigate } from "gatsby";

import ArupImage from "../../assets/Images/Homepage/HeroSection/new-image/arup.png";
import ChannelImage from "../../assets/Images/Homepage/HeroSection/new-image/Channel.png";
import NetworkImage from "../../assets/Images/Homepage/HeroSection/new-image/Network-plus.png";
import NhsImage from "../../assets/Images/Homepage/HeroSection/new-image/NHS.png";
import CERNImage from "../../assets/Images/Homepage/HeroSection/new-image/CERN.png";

function VentureRyteHero() {
  const [isHover, setIsHover] = useState(false);

  const toggleHover = () => {
    setIsHover(!isHover);
  };

  const imageList = [
    NhsImage,
    ArupImage,
    ChannelImage,
    CERNImage,
    NetworkImage,
  ];

  const handleGetTRLScore = () => {
    navigate("/contact-us");
  };

  return (
    <div className="ventureryte-hero-section">
      <div className="ventureryte-hero-background">
        <div className="ventureryte-hero-content body-container">
          <PracticeHeroContent
            brand="ventureRyte"
            title="Venture Capital 2.0"
            subtitle={
              <>
                Where <span className="text-highlight">Technology</span>,{" "}
                <span className="text-highlight">Capital</span> &{" "}
                <span className="text-highlight">Strategy</span> Converge
              </>
            }
            description={
              <>
                Build and scale your product with{" "}
                <strong>Technology Capital</strong>, not just cash. digiRyte
                combines <strong>Big 4 Lite strategy</strong>, Powerhouse
                engineering, TRL scoring, and MMP-first execution to help
                founders build products that scale, raise, and win.
              </>
            }
          >
            <RevealAnimation
              component={"div"}
              animation={"slide-up"}
              delay={0.3}
              className="hero-btn-wrapper"
              onMouseEnter={toggleHover}
              onMouseLeave={toggleHover}
            >
              <Button
                icon={
                  <img
                    className="effect-btn-svgicon"
                    src={RightArrowWhite}
                    alt=""
                  />
                }
                customClassName="ventureryte-primary-btn"
                color="primary"
                variant="contained"
                label="Get Your ventureRyte Score"
                onClick={handleGetTRLScore}
                tip="Get Your ventureRyte Score"
                tooltip="no"
                size="large"
              />
            </RevealAnimation>
          </PracticeHeroContent>

          {/* Visual Right - VC 2.0 Illustration */}
          <div className="visual-right">
            <div className="vc-illustration">
              {/* Central Circle - VC 2.0 Hub */}
              <div className="vc-hub">
                <div className="hub-ring"></div>
                <div className="hub-center">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5" />
                    <path d="M2 12l10 5 10-5" />
                  </svg>
                  <span className="hub-label">VC 2.0</span>
                </div>
              </div>

              {/* Orbiting Elements */}
              <div className="orbit-container">
                {/* Technology Orbit */}
                <div className="orbit-item technology">
                  <div className="orbit-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polyline points="16 18 22 12 16 6" />
                      <polyline points="8 6 2 12 8 18" />
                    </svg>
                  </div>
                  <div className="orbit-label">Technology</div>
                </div>

                {/* Capital Orbit */}
                <div className="orbit-item capital">
                  <div className="orbit-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="12" y1="1" x2="12" y2="23" />
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                    </svg>
                  </div>
                  <div className="orbit-label">Capital</div>
                </div>

                {/* Strategy Orbit */}
                <div className="orbit-item strategy">
                  <div className="orbit-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polygon points="12 2 2 7 12 12 22 7 12 2" />
                      <polyline points="2 17 12 22 22 17" />
                      <polyline points="2 12 12 17 22 12" />
                    </svg>
                  </div>
                  <div className="orbit-label">Strategy</div>
                </div>
              </div>

              {/* Connecting Lines */}
              <svg
                className="connection-lines"
                viewBox="0 0 400 400"
                fill="none"
              >
                <circle
                  cx="200"
                  cy="200"
                  r="140"
                  stroke="url(#lineGradient)"
                  strokeWidth="1"
                  strokeDasharray="4 4"
                  opacity="0.3"
                />
                <circle
                  cx="200"
                  cy="200"
                  r="100"
                  stroke="url(#lineGradient)"
                  strokeWidth="1"
                  strokeDasharray="4 4"
                  opacity="0.2"
                />
                <defs>
                  <linearGradient
                    id="lineGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#db4335" />
                    <stop offset="100%" stopColor="#e62415" />
                  </linearGradient>
                </defs>
              </svg>

              {/* Floating Metrics */}
              <div className="floating-metric metric-1">
                <div className="metric-value">12-18M</div>
                <div className="metric-label">Time Saved</div>
              </div>

              <div className="floating-metric metric-2">
                <div className="metric-value">Day 1</div>
                <div className="metric-label">Team Ready</div>
              </div>

              <div className="floating-metric metric-3">
                <div className="metric-value">MMP</div>
                <div className="metric-label">Not MVP</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trusted By Section */}
      <div className="trusted-by-section body-container">
        <div className="trusted-logos">
          {imageList?.map((item, keys) => (
            <div key={keys} className="logo-item">
              <img src={item} alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default VentureRyteHero;
